'use client';

import Link from 'next/link';
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { track404 } from '../lib/analytics';
import Navigation from './components/Navigation';
import Footer from './components/Footer';

export default function NotFound() {
    const pathname = usePathname();

    useEffect(() => {
        track404(pathname);
    }, [pathname]);

    return (
        <>
            <Navigation />
            <main className="min-h-screen flex items-center justify-center relative overflow-hidden">
                {/* Background Blobs */}
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-blue-500/20 rounded-full blur-[100px] -z-10"></div>

                <div className="container text-center px-4">
                    <h1 className="text-9xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-indigo-600 mb-4">
                        404
                    </h1>
                    <h2 className="text-2xl font-semibold mb-6 text-gray-200">
                        Sayfa Bulunamadı
                    </h2>
                    <p className="text-gray-400 max-w-md mx-auto mb-8">
                        Aradığınız sayfa silinmiş, adı değiştirilmiş veya geçici olarak kullanılamıyor olabilir.
                    </p>
                    <Link
                        href="/"
                        className="btn btn-primary btn-ripple inline-flex items-center gap-2"
                    >
                        <i className="fa-solid fa-house"></i>
                        Ana Sayfaya Dön
                    </Link>
                </div>
            </main>
            <Footer />
        </>
    );
}
